import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { IFilteredSubscriber } from '@shared/models/ODMatrix/ODMatrix.model';
import { start } from 'repl';

@Injectable({
  providedIn: 'root'
})
export class ODMatrizService {

  public sensorFilterSubject = new BehaviorSubject<IFilteredSubscriber>(undefined);
  filteredSensor$ = this.sensorFilterSubject.asObservable();

  public sensorFilterDatesSubject = new BehaviorSubject<IFilteredSubscriber>(undefined);
  filteredDatesSensor$ = this.sensorFilterDatesSubject.asObservable();

  public sensorFilterDeviceSubject = new BehaviorSubject<IFilteredSubscriber>(undefined);
  filteredDeviceSensor$ = this.sensorFilterDeviceSubject.asObservable();

  public sensorActiveSubject = new BehaviorSubject<any>(undefined);
  activeSensor$ = this.sensorActiveSubject.asObservable();

  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ) { }

  public getDataSinceSensorBySensorID(SensorID: any, selectedMatrix: any, datesMatrix: any): Observable<any> {
    let filtered1
    let filtered2

    if (selectedMatrix) {
      let arr: any = []
      selectedMatrix.percentage.map((data: any) => {
        let values = data.replace('%', '').replace(' ', '')

        if (values === 'Todos') {
          arr.push(
            {
              start: 0,
              end: 100
            }
          )
        } else {
          arr.push(
            {
              start: parseInt(values.split('-')[0]) * 1,
              end: parseInt(values.split('-')[1]) * 1
            }
          )
        }

      })

      filtered1 = {
        direction: selectedMatrix.direction === 'origin' ? 'ARRIVALS' : "DEPARTURES",
        percentage: arr
      }
    }
    else {
      filtered1 = {
        direction: 'ARRIVALS',
        percentage: [
          {
            start: 0,
            end: 100
          }
        ]
      }
    }

    if (datesMatrix) {
      filtered2 = datesMatrix.timestamp
    }
    else {
      filtered2 = '1h'
    }

    const requestBody = formatData(filtered1, filtered2);

    return this.httpClient.post(`${this.environment.trafficUrl}/device/sensor/${SensorID.id}/format-geo-json`, requestBody)
  }
}

function formatData(filtered1: any, filtered2: any) {
  const formData = new FormData();
  formData.append('recordsPerPage', '1000000');
  formData.append('page', '0');
  formData.append('typeMatrix', filtered1.direction);
  formData.append('period', filtered2);
  for (let i = 0; i < filtered1.percentage.length; i++) {
    formData.append(`matrix[${i}].start`, filtered1.percentage[i].start);
    formData.append(`matrix[${i}].end`, filtered1.percentage[i].end);
  }
  return formData;
}
